/* eslint-disable no-multi-str */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';

import Input from './common/Input';
import { Form } from 'react-bootstrap';
import { Editor } from '@tinymce/tinymce-react';
import { XSquare } from 'react-bootstrap-icons';
import Axios from 'axios';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";


const SingleGeneralImage = (props) => {


    const [imageMessage, setImageMessage] = useState(props.image.message);


    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);



    const populateClient = () => {
        setValue('imagetitle', props.image.title);
        setValue('imageorder', props.image.displayOrder);
    }

    useEffect(populateClient, []);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({});
    // const onSubmit = data => console.log(data);

    const onImageDetailsHandler = (data) => {
        coreContext.updateGeneralImage(data.imagetitle, imageMessage, data.imageorder, authContext.itemId, props.image.id);

    }



    const onImageMessageChangedHandler = (content, editor) => {
        setImageMessage(content);
    }


    const deleteImage = () => {
        const id = props.image.id;

        deleteGeneralImage(id);
    }

    const deleteGeneralImage = (id) => {

        Axios.post('/delete-general-image', { id }).then((response) => {
            const images = coreContext.general.general_images;
            const newImages = images.filter(image => image.id !== id);
            const cl = { ...coreContext.general, general_images: newImages };
            coreContext.setGeneral(cl);
        }).catch(err => { });
    }


    return (
        <div className="col-md-3"><img style={{ padding: 5 }} className="img-fluid" src={`http://${props.image.url}`} alt='gallery image' />
            <Form autoComplete='off' onSubmit={handleSubmit(onImageDetailsHandler)} noValidate>
                <Input label='Image Title' name='imagetitle' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Image Title' />


                <Form.Group>
                    <Editor
                        apiKey={coreContext.key}
                        value={imageMessage ? imageMessage : "Enter Message"}
                        init={{
                            height: 200,
                            menubar: 'insert',
                            file_picker_types: 'file image media',
                            plugins: [
                                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                            ],
                            toolbar:
                                'undo redo | formatselect | bold italic backcolor forecolor  | fontsize fontfamily lineheight | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent image | removeformat | code | help'
                        }}
                        onEditorChange={onImageMessageChangedHandler}
                    />
                </Form.Group>
                <Input label='Image Display Order' name='imageorder' minLength={1} maxLength={4} required={false} register={register} errors={errors} elementType='text' placeholder='Enter Image Reverse Display Order' />
                <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; <button onClick={() => deleteImage()} type="button" className="btn btn-danger btn-sm" title="Delete Image"> <XSquare size="12" /> </button> &nbsp;&nbsp; {coreContext.renderLoader()}
                <Input variant='danger' label={coreContext.message} elementType='label' />
            </Form>

        </div>
    )
}

export { SingleGeneralImage }